import React from "react";
import { CalendarDays, Clock3 } from "lucide-react";
import StatusBadge from "../../shared/components/StatusBadge";

const ScheduleTab = ({ schedules = [] }) => {
  return (
    <div className="space-y-4 p-5">
      {schedules.length > 0 ? (
        schedules.map((schedule) => (
          <div
            key={schedule.uuid}
            className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm"
          >
            {/* Header */}
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-amber-50 text-amber-600">
                  <CalendarDays size={16} />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-slate-800">
                    {schedule.schedule_name || "Unnamed Schedule"}
                  </h3>
                  <span className="text-[10px] text-slate-400 font-medium">
                    {schedule.schedule_code || "SCH-CODE"}
                  </span>
                </div>
              </div>
              {schedule.status && <StatusBadge status={schedule.status} />}
            </div>

            {/* Time / Hours */}
            <div className="mt-4 grid grid-cols-2 gap-4 border-t border-slate-50 pt-3 text-xs">
              <div>
                <p className="text-slate-400 font-medium flex items-center gap-1">
                  <Clock3 size={12} />
                  <span>Working Hours</span>
                </p>
                <p className="mt-1 font-semibold text-slate-700">
                  {schedule.start_time || "—"} - {schedule.end_time || "—"}
                </p>
              </div>

              <div>
                <p className="text-slate-400 font-medium flex items-center gap-1">
                  <Clock3 size={12} />
                  <span>Hours / Day</span>
                </p>
                <p className="mt-1 font-semibold text-slate-700">
                  {schedule.working_hours_per_day
                    ? `${schedule.working_hours_per_day} hrs`
                    : "—"}
                </p>
              </div>
            </div>

            {/* Days list */}
            <div className="mt-3 flex flex-wrap items-center gap-1 text-[10px] font-semibold">
              <span className="text-slate-400 mr-1 text-xs font-medium">Days:</span>
              {getWorkingDays(schedule).map((day) => (
                <span
                  key={day}
                  className="rounded-md bg-slate-50 border border-slate-100 px-1.5 py-0.5 text-slate-600"
                >
                  {day.slice(0, 3)}
                </span>
              ))}
              {schedule.week_off_days?.length > 0 && (
                <span className="ml-2 text-slate-400 font-medium text-[10px]">
                  (Off: {schedule.week_off_days.join(", ")})
                </span>
              )}
            </div>
          </div>
        ))
      ) : (
        <div className="flex min-h-[200px] items-center justify-center">
          <div className="text-center">
            <p className="text-sm font-medium text-slate-700">No schedules found</p>
            <p className="mt-1 text-xs text-slate-400">
              There are no work schedules available.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

const getWorkingDays = (schedule) => {
  if (Array.isArray(schedule.working_days) && schedule.working_days.length > 0) {
    return schedule.working_days;
  }
  const allDays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  const weekOffDays = schedule.week_off_days || [];
  return allDays.filter((day) => !weekOffDays.includes(day));
};

export default ScheduleTab;